/**
 * Lazy mount del toolbar de geo-sim.
 * - No monta en admin shell
 * - Lazy chunk: no pesa en first paint del visitante
 * - Role gate y simulación activa se resuelven dentro del toolbar
 */

import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { isAdminShellPath } from "@/lib/geoConsentRoutes";

const GeoSimToolbar = lazy(() =>
  import("./GeoSimToolbar").then((m) => ({ default: m.GeoSimToolbar })),
);

export function GeoSimToolbarHost() {
  const { pathname } = useLocation();
  if (isAdminShellPath(pathname)) return null;

  return (
    <Suspense fallback={null}>
      <GeoSimToolbar />
    </Suspense>
  );
}
